import TableListEmployeeNotes from "../../../../src/markdowns/sections/docs/employeenotes/response-list-employee-notes.md";
import TableRetrieveEmployeeNoteDetails from "../../../../src/markdowns/sections/docs/employeenotes/response-retrieve-employee-note-details.md";
import * as React from 'react';
export default {
  TableListEmployeeNotes,
  TableRetrieveEmployeeNoteDetails,
  React
};